import * as Yup from "yup";

export const GenerateReportFormSchema = Yup.object().shape({
  number: Yup.number().typeError("Ticket number must be a number"),
});
